module.exports = __webpack_public_path__ + "media/images/athletes/252-5f18b2f5c6a729756a558739b42a13ca.png";